
import * as types from 'src/store/types';
import * as service from 'src/service/dashboard';
import { EnumLifetimeType } from 'src/const/date';
import { captureError } from 'src/logger/errorLogger';
import { hasDedicatedCampaign, diagnosisSuggestionNum } from 'src/service';
import { isIOS14StatisticWhite } from 'src/const/whiteList';
import request from 'src/utils/request';
import apis from 'src/const/apis';

const dashboard = {
  namespaced: true,
  state: {
    startTime: '',
    endTime: '',
    overviewData: [],
    lifetime: EnumLifetimeType.unchosen,
    suggestionFilters: null,
    hasDedicatedCampaignExist: false,
    diagnosisSuggestionNumObj: { // diagnosis suggestion 诊断建议 不同情况的数目
      normal: 0, // 表现正常
      optimize: 0, // 建议优化
      shutdown: 0, // 建议关停
    },
  },
  getters: {
    diagnosisSuggestionNumObj: state => state.diagnosisSuggestionNumObj,
    startTime: state => state.startTime || '',
    endTime: state => state.endTime || '',
    overviewData: state => state.overviewData || [],
    // 数据统计部分使用，综合了当前账户是否创建过dedicated campaign 的状态和 是否白名单开启的状态  其他部分的同学不要使用！
    isDedicatedCampaignExist: state => state.hasDedicatedCampaignExist && isIOS14StatisticWhite(),
  },
  mutations: {
    [types.SET_END_TIME](state, endTime) {
      state.endTime = endTime;
    },
    [types.SET_START_TIME](state, startTime) {
      state.startTime = startTime;
    },
    [types.SET_OVERVIEW_DATA](state, data) {
      state.overviewData = data;
    },
    [types.SET_LIFE_TIME](state, data) {
      state.lifetime = data;
    },
    [types.SET_SUGGESTION_FILTERS](state, data) {
      state.suggestionFilters = data;
    },
    [types.SET_DIAGNOSIS_SUGGESTION_NUM_OBJ](state, data) {
      state.diagnosisSuggestionNumObj = data;
    },
    [types.SET_DEDICATED_CAMPAIGN](state, data) {
      state.hasDedicatedCampaignExist = data;
    },
    [types.SET_DEDICATED_CAMPAIGN](state, data) {
      state.hasDedicatedCampaignExist = data;
    },
  },
  actions: {
    async getSuggestionFilters({ commit, state }, args) {
      let data = null;
      try {
        const resp = await service.suggestionFilters(args);
        data = resp && resp.data ? resp.data : null;
      } catch (err) {
        captureError(err);
      }
      commit(types.SET_SUGGESTION_FILTERS, data);
      return data;
    },
    async getDiagnosisSuggestionNum({ commit }) {
      let data = {
        normal: 0,
        optimize: 0,
        shutdown: 0,
      };
      try {
        const resp = await diagnosisSuggestionNum();
        data = resp && resp.data ? resp.data : {
          normal: 0,
          optimize: 0,
          shutdown: 0,
        };
      } catch (err) {
        captureError(err);
      }
      commit(types.SET_DIAGNOSIS_SUGGESTION_NUM_OBJ, data);
      return data;
    },
    getIosWebAlertStatus({ commit }, data) { // 协议查询
      return request.get(apis.creative.protocolQuery, data);
    },
    async getDedicatedCampaignExist({ commit, state }) {
      let data = null;
      try {
        const resp = await hasDedicatedCampaign({
          setting_type: 4,
          setting_dimension: 1,
        });
        data = !!resp?.data?.is_exist;
      } catch (err) {
        data = null;
      }
      commit(types.SET_DEDICATED_CAMPAIGN, !!data);
    },
  },

};

export default dashboard;
